import { styled } from "@mui/material/styles";
import Radio from "@mui/material/Radio";
import { RadioCheckedIcon, RadioIcon } from "../../assets/icons";

export const RadioBox = styled(RadioIcon)(({ theme }) => ({
  width: 24,
  height: 24,
  ".Mui-focusVisible &": {
    outline: "2px auto rgba(19,124,189,.6)",
    outlineOffset: 2,
  },
  // "input:hover ~ &": {
  //   backgroundColor: theme.palette.mode === "dark" ? "#30404d" : "#ebf1f5",
  // },
  "input:disabled ~ &": {
    boxShadow: "none",
    background: theme.palette.mode === "dark" ? "rgba(57,75,89,.5)" : "rgba(206,217,224,.5)",
  },
}));

export const RadioBoxChecked = styled(RadioCheckedIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export function RadioBoxCustom(props: any) {
  return <Radio disableRipple checkedIcon={<RadioBoxChecked />} icon={<RadioBox />} {...props} />;
}
